import { useWeldAssignees, WeldMilestoneType } from '@bechtel/client-common';
import { Box, Icon, IconSize, Text, useSideSheetState } from '@bechtel/gds';
import { CommodityAssignee, CommodityStatusCode, PersonaType, Weld } from '@bechtel/types';
import { filter } from 'lodash';
import { FC } from 'react';
import { AssignWeldOwner } from '~/components/organisms/assign-weld-owner';
import { useWeldPermissions } from '~/hooks';
import { WeldAvatarGroup } from '../weld-avatar-group';
import { WeldHeaderStyled } from './styled';
export interface WeldHeaderProps {
  weld: Weld;
}

export const WeldHeader: FC<WeldHeaderProps> = ({ weld }) => {
  const { tag, type, commodityAssignees, currentMilestoneType, fitupRequest } = weld;
  const assignedCrewMembers: CommodityAssignee[] = useWeldAssignees(commodityAssignees);
  const { canAssignWeldForeman, canAssignFieldWeldEngineer, canReassignWeldForeman } =
    useWeldPermissions(assignedCrewMembers);
  const assignedForeman = filter(commodityAssignees, (assign) => assign.personaType === PersonaType.FOREMAN);
  const isFitupMilestone = currentMilestoneType?.name?.toUpperCase() == WeldMilestoneType.FITUP;
  const isWeldingRequired = fitupRequest && fitupRequest.isWeldingRequired ? fitupRequest.isWeldingRequired : false;
  const canAssignForeman =
    (isFitupMilestone ? isWeldingRequired : !isFitupMilestone) &&
    ((canAssignWeldForeman && assignedForeman.length == 0) || (canReassignWeldForeman && assignedForeman.length > 0));

  const showEditOwnerShip =
    (canAssignForeman || canAssignFieldWeldEngineer) &&
    weld.status?.status !== CommodityStatusCode.VT_APPROVED &&
    (weld.status?.status == CommodityStatusCode.CLAIMED ? canAssignFieldWeldEngineer : true);
  const { visible, open, close } = useSideSheetState(false);
  return (
    <WeldHeaderStyled>
      <Box
        mx={{ sm: '500' }}
        justifyContent={{ sm: 'space-between' }}
        alignItems={{ sm: 'center' }}
        style={{ width: '100%' }}
      >
        <Box flexDirection={{ sm: 'column' }}>
          <Box>
            <Text size="600" weight="600" family="graphik" color="white" data-testid="weld-tag">
              {tag}
            </Text>
          </Box>
          {type?.name && (
            <Box mt={{ sm: '400' }}>
              <Text size="400" weight="600" family="graphik" color="white" data-testid="weld-type">
                {type?.name}
              </Text>
            </Box>
          )}
        </Box>
        <Box>
          <WeldAvatarGroup weldAssignees={weld.commodityAssignees} currentMilestoneType={weld.currentMilestoneType} />
          {showEditOwnerShip && (
            <Box ml={{ sm: '450' }} mb={{ sm: '400' }}>
              <Icon onClick={open} fillColor="white" icon="edit" size={IconSize.MEDIUM} style={{ cursor: 'pointer' }} />
            </Box>
          )}
        </Box>
      </Box>
      {visible && <AssignWeldOwner onClose={close} weld={weld} openFromWeldModule={true}></AssignWeldOwner>}
    </WeldHeaderStyled>
  );
};
